<template>
  <div id="add-chairman-data">
    <v-card elevation="20" class="chairman-card">
      <!-- Premium Header -->
      <div class="header-premium">
        <v-container class="pa-0">
          <v-row class="align-center" no-gutters>
            <v-col cols="auto" class="d-flex align-center pa-4">
              <div class="icon-box-header">
                <v-icon size="32" color="white" class="icon-pulse">mdi-gavel</v-icon>
              </div>
              <div class="ml-4">
                <h2 class="title-header mb-1">{{ pageTitle }}</h2>
                <p class="subtitle-header mb-0">Add program chairman details</p>
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="d-flex align-center pa-4">
              <v-btn icon @click="closePrompt" class="close-btn-header" title="Close dialog">
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-sheet
        id="scrolling-techniques-7"
        class="overflow-y-auto content-sheet"
        max-height="700"
      >
        <v-container class="form-container pa-6">
          <v-form
            ref="form1"
            v-model="valid1"
            lazy-validation
            v-on:submit.prevent="submitData"
          >
            <v-card-text class="pa-0">
              <v-container class="pa-0">
                <!-- Member Type Selection -->
                <v-row wrap class="mb-6">
                  <v-col cols="12" sm="6" lg="6" md="6">
                    <label class="field-label-chairman">
                      <v-icon small class="label-icon-chairman">mdi-account-card</v-icon>
                      <span class="text-danger">*</span> Member Type
                    </label>
                    <v-select
                      :reduce="(option) => option.value"
                      v-model="MemberTypeId"
                      :items="MemberTypeIdOptions"
                      :rules="MemberTypeIdRules"
                      dense
                      required
                      outlined
                      class="custom-select"
                      prepend-icon="mdi-account"
                    />
                  </v-col>
                </v-row>

                <!-- Member Type = 1 (JCI Member) -->
                <v-card v-if="MemberTypeId == 1" class="section-card mb-6" elevation="4">
                  <div class="section-header">
                    <v-icon class="section-icon">mdi-account-tie</v-icon>
                    <span class="section-title">JCI Member</span>
                  </div>
                  <v-container class="pa-6">
                    <v-row wrap>
                      <v-col cols="12" sm="6" lg="4" md="4">
                        <label class="field-label-chairman">
                          <v-icon small class="label-icon-chairman">mdi-card-account-details</v-icon>
                          <span class="text-danger">*</span> Membership ID
                        </label>
                        <v-text-field
                          v-model="MembershipId"
                          :rules="MembershipIdRules"
                          placeholder="Enter Membership ID"
                          hint="Membership id for chairman"
                          append-outer-icon="mdi-magnify-plus"
                          :loading="MembershipIdLoading"
                          @click:append-outer="getMemberDetails"
                          outlined
                          dense
                          class="custom-input"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="4" md="4">
                        <label class="field-label-chairman">
                          <v-icon small class="label-icon-chairman">mdi-image</v-icon>
                          Chairman Photo
                        </label>
                        <br />
                        <div class="photo-box">
                          <img
                            :src="MemberData.MemberImage"
                            v-if="MemberData.Fullname != ''"
                            class="chairman-photo"
                          />
                          <v-icon v-else size="48" color="#ccc">mdi-image-plus</v-icon>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" lg="4" md="4">
                        <label class="field-label-chairman">
                          <v-icon small class="label-icon-chairman">mdi-information</v-icon>
                          Chairman Details
                        </label>
                        <div class="info-box">
                          <p class="info-name">{{ MemberData.Fullname }}</p>
                          <p class="info-designation">{{ MemberData.MemberDesignation }}</p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>

                <!-- Member Type = 2 (External Chairman) -->
                <v-card v-if="MemberTypeId == 2" class="section-card mb-6" elevation="4">
                  <div class="section-header">
                    <v-icon class="section-icon">mdi-account-plus</v-icon>
                    <span class="section-title">External Chairman</span>
                  </div>
                  <v-container class="pa-6">
                    <!-- Chairman Name and Description -->
                    <v-row wrap class="mb-6">
                      <v-col cols="12" sm="6" lg="6" md="6">
                        <label class="field-label-chairman">
                          <v-icon small class="label-icon-chairman">mdi-account-circle</v-icon>
                          <span class="text-danger">*</span> Chairman Name
                        </label>
                        <v-text-field
                          v-model="MemberName"
                          :rules="MemberNameRules"
                          placeholder="Enter chairman name"
                          hint="Full name of the chairman"
                          required
                          outlined
                          dense
                          class="custom-input"
                          prepend-icon="mdi-account"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" lg="6" md="6">
                        <label class="field-label-chairman">
                          <v-icon small class="label-icon-chairman">mdi-text-box</v-icon>
                          Description <small> (optional)</small>
                        </label>
                        <v-text-field
                          v-model="MemberDetails"
                          :rules="MemberDetailsRules"
                          placeholder="Chairman designation/details"
                          hint="Position or role of the chairman"
                          required
                          outlined
                          dense
                          class="custom-input"
                          prepend-icon="mdi-briefcase"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <!-- Image Upload Section -->
                    <v-row wrap class="mb-6">
                      <v-col cols="12" sm="6" lg="6" md="6">
                        <label class="field-label-chairman">
                          <v-icon small class="label-icon-chairman">mdi-image-plus</v-icon>
                          Upload Image
                          <small> (optional)</small>
                          <p class="notes-chairman">
                            (JPG, PNG only - Max 5MB)
                          </p>
                        </label>
                        <v-file-input
                          :clearable="false"
                          truncate-length="25"
                          accept="image/png, image/jpeg"
                          placeholder="Upload Chairman Photo"
                          prepend-icon="mdi-cloud-upload"
                          append-outer-icon="mdi-delete"
                          v-model="UploadImage1"
                          @change="addImage(1)"
                          class="file-input-custom"
                        >
                          <template v-slot:append-outer>
                            <v-icon color="#ef5350" @click="deleteImage(1)">
                              mdi-trash-can
                            </v-icon>
                          </template>
                        </v-file-input>
                      </v-col>

                      <!-- Image Edit Options -->
                      <v-col cols="12" sm="6" lg="6" md="6">
                        <label class="field-label-chairman">
                          <v-icon small class="label-icon-chairman">mdi-pencil-ruler</v-icon>
                          Image Edit Options
                        </label>
                        <div class="actions-container">
                          <v-btn
                            fab
                            x-small
                            color="#3a67b1"
                            @click.prevent="flip(true, false)"
                            class="edit-btn"
                            title="Flip horizontally"
                          >
                            <v-icon small>mdi-flip-h</v-icon>
                          </v-btn>
                          <v-btn
                            fab
                            x-small
                            color="#0097d7"
                            @click.prevent="flip(false, true)"
                            class="edit-btn"
                            title="Flip vertically"
                          >
                            <v-icon small>mdi-flip-v</v-icon>
                          </v-btn>
                          <v-btn
                            fab
                            x-small
                            color="#56bda3"
                            @click.prevent="rotate(90)"
                            class="edit-btn"
                            title="Rotate right"
                          >
                            <v-icon small>mdi-rotate-right</v-icon>
                          </v-btn>
                          <v-btn
                            fab
                            x-small
                            color="#edbe38"
                            @click.prevent="rotate(-90)"
                            class="edit-btn"
                            title="Rotate left"
                          >
                            <v-icon small>mdi-rotate-left</v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                    </v-row>

                    <!-- Image Preview -->
                    <v-row wrap>
                      <v-col cols="12">
                        <label class="field-label-chairman">
                          <v-icon small class="label-icon-chairman">mdi-image-preview</v-icon>
                          Image Preview
                        </label>
                        <div class="preview-container">
                          <cropper
                            ref="cropper"
                            :src="MemberImage.ImageUrl"
                            :stencil-props="{
                              handlers: {},
                              movable: false,
                              scalable: false,
                            }"
                            :stencil-size="StencilSize"
                            image-restriction="stencil"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>

                <!-- Action Buttons -->
                <v-container v-if="MemberTypeId != ''">
                  <v-row wrap class="mt-6">
                    <v-col align="center" cols="12" md="12">
                      <v-btn
                        @click="closePrompt"
                        class="action-btn-cancel"
                      >
                        <v-icon left>mdi-close</v-icon>
                        Cancel
                      </v-btn>
                      <v-btn
                        :disabled="!valid1"
                        @click.prevent="submitData"
                        :loading="SubmitFlag"
                        class="action-btn-submit"
                      >
                        <v-icon left>mdi-plus-circle</v-icon>
                        Add Chairman
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-container>
            </v-card-text>
          </v-form>
        </v-container>
      </v-sheet>
      <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,

      LoadingFlag: false,
      SubmitFlag: false,

      FacultyTypeIdRules: [(v) => !!v || "Faculty type is required"],
      FacultyTypeId: "",
      FacultyTypeIdOptions: [],
      FacultyTypeIdOptionsLoading: false,

      MemberTypeIdRules: [(v) => !!v || "Member type is required"],
      MemberTypeId: "",
      MemberTypeIdOptions: [
        { value: "", text: "- Select -" },
        { value: 1, text: "Member" },
        { value: 2, text: "Non Member" },
      ],
      MemberTypeIdOptionsLoading: false,

      MembershipId: "",
      MembershipIdRules: [(v) => !!v || "Membership id is required"],
      MembershipIdLoading: false,

      MemberName: "",
      MemberNameRules: [(v) => !!v || "Chairman name is required"],

      MemberDetails: "",
      MemberDetailsRules: [
        // (v) => !!v || "Faculty details required"
      ],

      MemberData: {},

      image: {
        src: "",
        type: null,
      },

      current_photo: "",

      UploadImage1: {},
      MemberImage: { src: null },

      StencilSize: { width: 250, height: 250 },
    };
  },
  computed: {},
  watch: {
    FacultyTypeIdOptions: function () {
      console.log("watch FacultyTypeIdOptions");
      this.LoadingFlag = false;
      this.FacultyTypeIdOptionsLoading = false;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      this.closePrompt();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt(member = {}) {
      console.log("closePrompt called");
      console.log({ member });
      this.$emit("hideDialog", member);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      //   this.getFacultyTypeIdOptions();
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    flip(x, y) {
      console.log("flip x=" + x + ", y=" + y);
      this.$refs.cropper.flip(x, y);
    },
    rotate(angle) {
      console.log("rotate=" + angle);
      this.$refs.cropper.rotate(angle);
    },
    addImage(id) {
      console.log("addImage called");
      console.log({ id });
      switch (id) {
        case 1:
          var file = this.UploadImage1;
          console.log({ file });
          var src = URL.createObjectURL(file);
          console.log({ src });
          if (this.MemberImage.src) {
            URL.revokeObjectURL(this.MemberImage.src);
          }
          var FileType = file.type;
          console.log({ FileType });
          this.MemberImage = {
            ImageName: file.name,
            ImageType: FileType,
            ImageUrl: src,
            UploadedImage: file,
          };
          break;

        default:
          break;
      }
    },
    deleteImage(id) {
      console.log("deleteImage called");
      console.log({ id });
      switch (id) {
        case 1:
          this.MemberImage = {
            ImageName: null,
            ImageType: null,
            ImageUrl: null,
            UploadedImage: null,
          };
          this.UploadImage1 = {};
          break;

        default:
          break;
      }
    },
    getFacultyTypeIdOptions() {
      console.log("getFacultyTypeIdOptions called");
      this.FacultyTypeIdOptionsLoading = true;
      var selectbox1_source = "FacultyTypeId";
      var selectbox1_destination = "FacultyTypeIdOptions";
      var selectbox1_url = "api/sub-category/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        CategoryMainId: 17,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getMemberDetails() {
      console.log("getMemberDetails is called");

      var MembershipId = this.MembershipId;
      console.log("MembershipId=" + MembershipId);

      if (MembershipId != "") {
        this.MembershipIdLoading = true;
        this.MemberData = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/search";
        var upload = {
          UserInterface: 2,
          MembershipId: MembershipId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SubmitFlag = false;
            thisIns.StartupLoadingFlag = false;
            thisIns.MembershipIdLoading = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.MemberData = records;
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.MembershipIdLoading = false;
          });
      } else {
        var message = "";
        if (MembershipId == "") {
          message += "Membership Id should not be empty.";
        }
        this.toast("error", message);
      }
    },
    submitData() {
      console.log("submitData is called");
      var message = "";
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        // Get Member Type details

        var id2 = this.MemberTypeId;
        var index2 = this.MemberTypeIdOptions.map((e) => e.value).indexOf(id2);
        console.log("id2=" + id2 + ", index2=" + index2);
        var text2 = this.MemberTypeIdOptions[index2].text;
        console.log("text2=" + text2);

        if (id2 == 1) {
          var MemberData = this.MemberData;
          console.log({ MemberData });
          var tempData = {
            MembershipId: this.MembershipId,
            Fullname: MemberData.Fullname,
            MemberImage: MemberData.MemberImage,
            MemberDesignation: MemberData.MemberDesignation,
          };
          console.log({ tempData });
          this.closePrompt(tempData);
        } else {
          const { canvas } = this.$refs.cropper.getResult();
          if (canvas) {
            var FileType = this.MemberImage.ImageType;
            var ImageName = this.MemberImage.ImageName;
            console.log({ FileType });
            console.log({ ImageName });
            //   const form = new FormData();
            canvas.toBlob((blob) => {
              // formData.append("ProfilePicture", blob, "logo.png");
              var tempData = {
                MembershipId: this.MembershipId,
                Fullname: this.MemberName,
                MemberImage: canvas.toDataURL(),
                MemberDesignation: this.MemberDetails,
                UploadedImage: blob,
                UploadedImageName: ImageName,
              };
              console.log({ tempData });
              this.closePrompt(tempData);
              // Perhaps you should add the setting appropriate file format here
            }, FileType);
          } else {
            message += "Kindly select image. ";
            // this.toast("error", message, true);
            var tempData = {
              MembershipId: this.MembershipId,
              Fullname: this.MemberName,
              MemberImage: this.MemberImage.src,
              MemberDesignation: this.MemberDetails,
            };
            console.log({ tempData });
            this.closePrompt(tempData);
          }
        }
      } else {
        if (validate1 == false) {
          message += "Kindly fill the required fields. ";
        }
        this.toast("error", message, true);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
// ============================================
// COLOR VARIABLES
// ============================================
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$seaform: #56bda3;
$danger-color: #ef5350;
$text-white: #ffffff;
$text-primary: #333333;
$text-off-black: #2c3e50;
$text-90-black: #666666;

#add-chairman-data {
  // ============================================
  // CARD CONTAINER
  // ============================================
  .chairman-card {
    border-radius: 20px !important;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
    background: linear-gradient(135deg, #ffffff 0%, #f5f9fc 100%) !important;
    border: none !important;
  }

  // ============================================
  // PREMIUM HEADER
  // ============================================
  .header-premium {
    background: linear-gradient(135deg, $aqua 0%, $navy 100%);
    position: relative;
    overflow: hidden;
    box-shadow: 0 12px 40px rgba(58, 103, 177, 0.3);

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at 20% 50%, rgba(237, 190, 56, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(86, 189, 163, 0.1) 0%, transparent 50%);
      pointer-events: none;
    }
  }

  .icon-box-header {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(15px);
    border-radius: 16px;
    padding: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    border: 2px solid rgba(255, 255, 255, 0.3);
    animation: float 4s ease-in-out infinite;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 56px;
    min-height: 56px;
  }

  .title-header {
    font-size: 24px;
    font-weight: 900;
    color: $text-white;
    letter-spacing: 0.6px;
    text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
    margin: 0;
  }

  .subtitle-header {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }

  .close-btn-header {
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    color: white !important;
    border-radius: 12px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.25) !important;
      transform: scale(1.1);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    }
  }

  // ============================================
  // CONTENT SHEET
  // ============================================
  .content-sheet {
    background: linear-gradient(135deg, #f5f7fa 0%, #e8f0f7 100%);
  }

  .form-container {
    background: transparent;
  }

  // ============================================
  // FIELD LABELS & INPUTS
  // ============================================
  .field-label-chairman {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    font-weight: 800;
    color: $navy;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 12px;
  }

  .label-icon-chairman {
    color: $aqua;
    font-size: 18px;
  }

  .text-danger {
    color: $danger-color;
    font-weight: 900;
  }

  .notes-chairman {
    font-size: 11px;
    color: $text-90-black;
    font-weight: 500;
    margin: 4px 0 0 0;
    padding: 0;
  }

  ::v-deep .custom-select,
  ::v-deep .custom-input {
    .v-field__outline {
      border-color: rgba(58, 103, 177, 0.3) !important;
      border-width: 2px !important;
    }

    .v-field:hover .v-field__outline {
      border-color: rgba(58, 103, 177, 0.5) !important;
    }

    .v-field--focused .v-field__outline {
      border-color: $navy !important;
      border-width: 2px !important;
      box-shadow: 0 0 0 3px rgba(58, 103, 177, 0.1);
    }

    .v-field {
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.9);

      input {
        font-size: 14px;
        color: $text-off-black;
      }
    }

    .v-input__prepend {
      color: $aqua !important;
    }
  }

  // ============================================
  // SECTION CARD
  // ============================================
  .section-card {
    border-radius: 16px !important;
    border: 2px solid rgba(58, 103, 177, 0.15) !important;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.95) 100%) !important;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      border-color: rgba(0, 151, 215, 0.3) !important;
      box-shadow: 0 12px 32px rgba(58, 103, 177, 0.15) !important;
      transform: translateY(-2px);
    }
  }

  .section-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 20px;
    background: linear-gradient(135deg, rgba(58, 103, 177, 0.08) 0%, rgba(0, 151, 215, 0.08) 100%);
    border-bottom: 3px solid rgba(58, 103, 177, 0.15);
  }

  .section-icon {
    color: $aqua;
    font-size: 26px;
    flex-shrink: 0;
  }

  .section-title {
    font-size: 14px;
    font-weight: 800;
    color: $navy;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin: 0;
  }

  // ============================================
  // PHOTO BOX & INFO BOX
  // ============================================
  .photo-box {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(240, 248, 255, 0.9) 100%);
    border: 3px dashed rgba(58, 103, 177, 0.3);
    border-radius: 12px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    transition: all 0.3s ease;

    &:hover {
      border-color: rgba(0, 151, 215, 0.5);
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(240, 248, 255, 0.98) 100%);
    }
  }

  .chairman-photo {
    max-width: 100%;
    max-height: 100px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .info-box {
    background: linear-gradient(135deg, rgba(0, 151, 215, 0.08) 0%, rgba(86, 189, 163, 0.08) 100%);
    border: 2px solid rgba(58, 103, 177, 0.2);
    border-radius: 12px;
    padding: 16px;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .info-name {
    font-size: 14px;
    font-weight: 800;
    color: $navy;
    margin: 0 0 8px 0;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .info-designation {
    font-size: 12px;
    color: $text-90-black;
    font-weight: 600;
    margin: 0;
  }

  // ============================================
  // IMAGE EDIT OPTIONS
  // ============================================
  .actions-container {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    padding: 10px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 12px;
    border: 2px dashed rgba(58, 103, 177, 0.2);
  }

  .edit-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;

    &:hover {
      transform: translateY(-2px) scale(1.05);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
    }
  }

  // ============================================
  // PREVIEW CONTAINER
  // ============================================
  .preview-container {
    background: white;
    border-radius: 12px;
    border: 3px solid rgba(58, 103, 177, 0.2);
    padding: 16px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
    min-height: 300px;

    .vue-cropper {
      border-radius: 8px;
      overflow: hidden;
    }
  }

  ::v-deep .file-input-custom {
    .v-field {
      background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(240, 248, 255, 0.95) 100%);
      border-radius: 12px;
    }

    .v-field__outline {
      border-color: rgba(0, 151, 215, 0.4) !important;
      border-width: 2px !important;
    }
  }

  // ============================================
  // ACTION BUTTONS
  // ============================================
  .action-btn-cancel {
    background: linear-gradient(135deg, #ef5350 0%, #e53935 100%) !important;
    color: $text-white !important;
    font-weight: 800;
    padding: 12px 32px !important;
    border-radius: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 8px 24px rgba(239, 83, 80, 0.3) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    margin: 0 8px;
    font-size: 13px;
    border: none !important;

    &:hover {
      background: linear-gradient(135deg, #e53935 0%, #d32f2f 100%) !important;
      box-shadow: 0 12px 32px rgba(239, 83, 80, 0.4) !important;
      transform: translateY(-2px);
    }
  }

  .action-btn-submit {
    background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
    color: $text-white !important;
    font-weight: 800;
    padding: 12px 32px !important;
    border-radius: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    box-shadow: 0 8px 24px rgba(58, 103, 177, 0.3) !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    margin: 0 8px;
    font-size: 13px;
    border: none !important;

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, $aqua 0%, $navy 100%) !important;
      box-shadow: 0 12px 32px rgba(58, 103, 177, 0.4) !important;
      transform: translateY(-2px);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  // ============================================
  // ANIMATIONS
  // ============================================
  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-8px);
    }
  }

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  // ============================================
  // RESPONSIVE
  // ============================================
  @media (max-width: 600px) {
    .title-header {
      font-size: 18px;
    }

    .subtitle-header {
      font-size: 11px;
    }

    .action-btn-submit,
    .action-btn-cancel {
      padding: 10px 24px !important;
      margin: 4px !important;
    }

    .actions-container {
      gap: 6px;
    }

    .edit-btn {
      width: 36px !important;
      height: 36px !important;
    }

    .preview-container {
      min-height: 200px;
    }
  }
}
</style>